import React from 'react';
import { useRouter } from 'next/router';

import { Page } from '@tager/web-components';
import { isServer } from '@tager/web-core';

import { CustomApp_PageContext } from '@/typings/hocs';
import { getSharedThunkList } from '@/utils/thunks';
import Layout from '@/components/Layout';
import {
  getBlogCategoryListThunk,
  getSeoParamsThunk,
  selectSeoParams,
} from '@/store/reducers/tager/blog';
import { useTypedSelector } from '@/store/store';
import ErrorPage from '@/pages/_error';
import { convertErrorToProps, getCurrentPath } from '@/utils/common';
import Blog from '@/modules/Blog';

type Props =
  | {
      pageType: 'BlogPage';
    }
  | {
      pageType: 'ErrorPage';
      error: Error;
    };

function BlogPage(props: Props) {
  const seoParams = useTypedSelector(selectSeoParams);

  const router = useRouter();
  const currentPath = getCurrentPath(router);

  const canonicalUrl = process.env.NEXT_PUBLIC_ORIGIN + currentPath;

  if (props.pageType === 'ErrorPage') {
    return <ErrorPage {...convertErrorToProps(props.error)} />;
  }

  return (
    <Page
      title={seoParams?.indexPageTitle}
      description={seoParams?.indexPageDescription}
      canonicalUrl={canonicalUrl}
    >
      <Layout>
        <Blog />
      </Layout>
    </Page>
  );
}

export default BlogPage;

BlogPage.getInitialProps = async (
  context: CustomApp_PageContext
): Promise<Props> => {
  const { store } = context;

  try {
    const requests = Promise.all([
      ...getSharedThunkList(store.dispatch),
      Promise.all([
        store.dispatch(getBlogCategoryListThunk()),
        store.dispatch(getSeoParamsThunk()),
      ]),
    ]);

    if (isServer()) {
      await requests;
    }

    return {
      pageType: 'BlogPage',
    };
  } catch (error) {
    return { pageType: 'ErrorPage', error };
  }
};
